import { initials } from '@/lib/initials';
import { cn } from '@/lib/utils';

const SIZES = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-xl',
};

const TONES = {
  /** Les autres personnes (listes, organigramme) */
  neutral: 'bg-slate-100 text-slate-600',
  /** Soi-même, la fiche affichée, la personne choisie */
  accent: 'bg-blue-100 text-blue-700',
};

/** Pastille d'initiales d'une personne (prénom puis nom sans particule : initials) */
export function Avatar({
  firstName,
  lastName,
  size = 'md',
  tone = 'neutral',
  className,
}: {
  firstName: string;
  lastName: string;
  size?: keyof typeof SIZES;
  tone?: keyof typeof TONES;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'rounded-full flex items-center justify-center font-bold uppercase flex-shrink-0',
        SIZES[size],
        TONES[tone],
        className,
      )}
    >
      {initials(firstName, lastName)}
    </span>
  );
}
